import { createSlice, PayloadAction } from '@reduxjs/toolkit'

// Up to this many listings can sit in the side-by-side comparison at once.
export const COMPARE_LIMIT = 3

const initialState = {
  search: '',
  sort: 'createdAt desc',
  compareIds: [] as string[],
}

const propertySearchSlice = createSlice({
  name: 'propertySearch',
  initialState,
  reducers: {
    setValue(state, action) {
      state.search = action.payload
    },
    clearValue(state) {
      state.search = ''
    },
    setSort(state, action) {
      state.sort = action.payload
    },
    toggleCompare(state, action: PayloadAction<string>) {
      const id = action.payload
      if (state.compareIds.includes(id)) {
        state.compareIds = state.compareIds.filter((existing) => existing !== id)
      } else if (state.compareIds.length < COMPARE_LIMIT) {
        state.compareIds.push(id)
      }
    },
    clearCompare(state) {
      state.compareIds = []
    },
  },
})

export const { setValue, clearValue, setSort, toggleCompare, clearCompare } =
  propertySearchSlice.actions
export default propertySearchSlice.reducer
